/**
 * Aplica uma máscara de formatação em um valor
 * @param value - Valor a ser formatado
 * @param format - Formato da máscara (ex: "#####-###", "(##) #####-####")
 * @returns Valor formatado
 */
export const applyMask = (value: string, format: string): string => {
  if (!value) return "";

  // Remove todos os caracteres não numéricos
  const numericValue = value.replace(/\D/g, "");

  let formattedValue = "";
  let numericIndex = 0;

  // Itera sobre o formato e aplica a máscara
  for (
    let i = 0;
    i < format.length && numericIndex < numericValue.length;
    i++
  ) {
    if (format[i] === "#") {
      formattedValue += numericValue[numericIndex];
      numericIndex++;
    } else {
      formattedValue += format[i];
    }
  }

  return formattedValue;
};

/**
 * Remove a máscara de um valor formatado
 * @param value - Valor formatado
 * @returns Valor sem formatação (apenas números)
 */
export const removeMask = (value: string): string => {
  return value.replace(/\D/g, "");
};

/**
 * Verifica se o valor está completo de acordo com o formato
 * @param value - Valor a ser verificado
 * @param format - Formato da máscara
 * @returns True se o valor está completo
 */
export const isValueComplete = (value: string, format: string): boolean => {
  const numericValue = removeMask(value);
  const expectedLength = format.split("").filter((char) => char === "#").length;
  return numericValue.length === expectedLength;
};
